export enum DateRange {
    Past,
    Inmediate,
    Forecast,
    TodayTomorrow
}